import assetPath from '/app/packages/lebenslauf/articles/src/assets/das-bewerbungsverfahren-ablauf-und-tipps.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')